

import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ProtectedRoute from "./components/ProtectedRoute";
import { TokenExpirationProvider, useTokenExpiration } from "./context/TokenExpirationContext";
import TokenExpiredModal from "./components/TokenExpiredModal/TokenExpiredModal";
import { setTokenExpiredCallback } from "./api/axios";
import { useTokenValidation } from "./hooks/useTokenValidation";

import Layout from "./components/Layout/Layout";
import LoginPage from "./pages/Login/Login";

import Dashboard from "./pages/dashboard/Dashboard";
import Billing from "./pages/Billing/Billing";
import Service from "./pages/Service/Service";
import VendorList from "./pages/VendorList/VendorList";
import CategoryDetails from "./pages/CategoryDetails/CategoryDetails";
import UserManagement from "./pages/UserManagement/UserManagement";
import VendorDetails from "./pages/UserManagement/VendorDetails";
import CustomerDetails from "./pages/UserManagement/CustomerDetails";
import InfluencerDetails from "./pages/UserManagement/InfluencerDetails";
import PortfolioApproval from "./pages/PortfolioApproval/PortfolioApproval";
import PlanManagement from "./pages/PlanManagement/PlanManagement";
import PlanDetail from "./pages/PlanManagement/PlanDetail";
import OrderHistory from "./pages/OrderHistory/OrderHistory";
import PostManagement from "./pages/PostManagement/PostManagement";
import AgentManagement from "./pages/AgentManagement/AgentManagement";
import AgentDetails from "./pages/AgentManagement/AgentDetails";
import HandpickedVendors from "./components/HandpickedVendors/HandpickedVendors";
import FeaturedCategories from "./components/FeaturedCategories/FeaturedCategories";
import GalleryImages from "./components/GalleryImages/GalleryImages";
import CoinPrice from "./pages/CoinPrice/CoinPrice";
import CoinPercentUse from "./pages/CoinPercentUse/CoinPercentUse";
import FAQ from "./pages/FAQ/FAQ";
import HelpSupport from "./pages/HelpSupport/HelpSupport";
import Banner from "./pages/Banner/Banner";
import WebsiteContent from "./pages/Website/WebsiteContent";
import Invoices from "./pages/Invoices/Invoices";
import Target from './pages/Target/Target';
import TargetManagement from './pages/Target/TargetManagement';
import Settings from "./pages/Settings/Settings";
import DeletedUsers from "./pages/DeletedUsers/DeletedUsers";
import AuditLogs from "./pages/AuditLogs/AuditLogs";
import { States, Commissionaries, Districts } from "./pages/StateManagement";
import SendNotification from "./pages/Notifications/SendNotification";
import BlogManagement from "./pages/Blog/Blog";
import SeoContentManagement from "./pages/SeoContent/SeoContent";
import ThankYouPageManagement from "./pages/ThankYouPage/ThankYouPage";
import MetaAdsManagement from "./pages/MetaAds/MetaAdsManagement";
import ClaimedVendors from "./pages/ClaimedVendors/ClaimedVendors";

const AppContent = () => {
  const { showExpiredModal, handleTokenExpired, handleLoginRedirect } = useTokenExpiration();
  const location = useLocation();
  const isLoginPage = location.pathname === '/';

  //  useTokenValidation();

  // useEffect(() => {
  //   setTokenExpiredCallback(handleTokenExpired);
  // }, [handleTokenExpired]);
  //  handleTokenExpired()

  console.log('Modal state:', showExpiredModal, 'Is login page:', isLoginPage);

  return (
    <>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="dashboard" element={<Dashboard />} />
                  <Route path="billing" element={<Billing />} />
                  <Route path="service" element={<Service />} />
                  <Route path="vendor-list/:categoryId" element={<VendorList />} />
                  <Route path="category-details/:categoryId" element={<CategoryDetails />} />
                  <Route path="user-management" element={<UserManagement />} />
                  <Route path="vendor-details/:id" element={<VendorDetails />} />
                  <Route path="customer-details/:id" element={<CustomerDetails />} />
                  <Route path="influencer-details/:id" element={<InfluencerDetails />} />
                  <Route path="plan-management" element={<PlanManagement />} />
                  <Route path="plan-detail/:id" element={<PlanDetail />} />
                  <Route path="order-history" element={<OrderHistory />} />
                  <Route path="post-management" element={<PostManagement />} />
                  <Route path="deleted-users" element={<DeletedUsers />} />
                  <Route path="agent-management" element={<AgentManagement />} />
                  <Route path="agent-management/:id" element={<AgentDetails />} />
                  <Route path="handpicked-vendors" element={<HandpickedVendors />} />
                  <Route path="featured-categories" element={<FeaturedCategories />} />
                  <Route path="gallery-images" element={<GalleryImages />} />
                  <Route path="portfolio-approval" element={<PortfolioApproval />} />
                  <Route path="coin-price" element={<CoinPrice />} />
                  <Route path="coin-percent-use" element={<CoinPercentUse />} />
                  <Route path="faq" element={<FAQ />} />
                  <Route path="help-support" element={<HelpSupport />} />
                  <Route path="banners" element={<Banner />} />
                  <Route path="website-content" element={<WebsiteContent />} />
                  <Route path="invoices" element={<Invoices />} />
                  <Route path="target" element={<Target />} />
                  <Route path="target-management" element={<TargetManagement />} />
                  <Route path="states" element={<States />} />
                  <Route path="commissionaries" element={<Commissionaries />} />
                  <Route path="districts" element={<Districts />} />
                  <Route path="commissionaries/:stateId" element={<Commissionaries />} />
                  <Route path="districts/:commissionaryId" element={<Districts />} />
                  <Route path="audit-logs" element={<AuditLogs />} />
                  <Route path="notifications" element={<SendNotification />} />
                  <Route path="settings" element={<Settings />} />
                  <Route path="blog-management" element={<BlogManagement />} />
                  <Route path="seo-content" element={<SeoContentManagement />} />
                  <Route path="thank-you-page" element={<ThankYouPageManagement />} />
                  <Route path="meta-ads" element={<MetaAdsManagement />} />
                  <Route path="claimed-vendors" element={<ClaimedVendors />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>

      <TokenExpiredModal
        show={showExpiredModal && !isLoginPage}
        onLogin={handleLoginRedirect}
      />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

function App() {
  return (
    <TokenExpirationProvider>
      <Router>
        <AppContent />
      </Router>
    </TokenExpirationProvider>
  );
}


export default App;

